import {
  PageStore
} from 'bernie-plugin-mobx';
import {
  Controller,
  codeSplit,
  FetchOptions,
  FetchPageOptions
} from 'bernie-core';
import { PageData } from 'bernie-http';
import { PageId, PageURL } from 'utils/page-identity';
import { Localization } from 'bernie-l10n';
import '../client/temp-common-imports';

export class CarRnRController implements Controller {
  public bundles = [];
  public path = PageURL.RNR;
  public routeName = 'rulesAndRestrictions';
  public pageId = PageId.RNR;

  public component = codeSplit(() => import(/* webpackChunkName: 'car-rnr-page' */ '../views/car-rnr-page'));

  public exact = true;

  public async fetch(options: FetchOptions): Promise<any> {
    if (!options || !options.stores) {
      return Promise.reject('RNR received invalid FetchOptions');
    }
    const { stores } = options;
    const page: PageStore = stores.get<PageStore>('page');
    page.pageName = this.pageId.split(',')[0];
    
    return Promise.resolve({});
  }

  public fetchPageData(fetchPageOptions: FetchPageOptions): Promise<PageData> {
    const localizer = new Localization(fetchPageOptions.context.locale);
    const defaultPageTitle = localizer.formatText('page.title.rnr.default',fetchPageOptions.context.site.name);

    return Promise.resolve({ title : defaultPageTitle }) as Promise<PageData>;
  }
}
